import axios from 'axios'

const getMatches = async (page = 1, limit = 10, matchStatus) => {
    try {
        const accessToken = localStorage.getItem('token');
        if (!accessToken) {
            throw new Error("Please Login!!!");
        }
        const headers = {
            authorization: `${accessToken}`,
        };
        // Send pagination query params so API returns 10 per page by default
        const params = { page, limit };
        if (matchStatus && matchStatus !== 'all') {
            params.matchStatus = matchStatus;
        }
        let { data } = await axios.get(`${window.host}/match`, { headers, params });
        return data;
    }
    catch(err){
        if(process.env.NODE_ENV==='dev'){
            console.error(err.response.data.message);
        }
        return  []
    }
}

const getMatch = async (id)=>{
    try{
        const accessToken = localStorage.getItem('token');
        if (!accessToken) {
            throw new Error("Please Login!!!");
        }
        const headers = {
            authorization: `${accessToken}`,
        };
        let { data } = await axios.get(`${window.host}/match/${id}`, { headers });
        return data;
    }
    catch(err){
        if(process.env.NODE_ENV==='dev'){
            console.error(err.response.data.message);
        }
        return  []
    }
}

const updateMatchStatus = async (id, matchStatus) => {
    try {
        const accessToken = localStorage.getItem('token');
        if (!accessToken) {
            throw new Error("Please Login!!!");
        }
        const headers = {
            authorization: `${accessToken}`,
            'Content-Type': 'application/json',
        };
        let { data } = await axios.put(`${window.host}/match/${id}`, { matchStatus }, { headers });
        return data;
    } catch (err) {
        if (process.env.NODE_ENV === 'dev') {
            console.error(err.response?.data?.message || err.message);
        }
        return null;
    }
};

const deleteMatch = async (id) => {
    try {
        const accessToken = localStorage.getItem('token');
        if (!accessToken) {
            throw new Error("Please Login!!!");
        }
        const headers = {
            authorization: `${accessToken}`,
        };
        let { data } = await axios.delete(`${window.host}/match/${id}`, { headers });
        return data;
    } catch (err) {
        if (process.env.NODE_ENV === 'dev') {
            console.error(err.response?.data?.message || err.message);
        }
        return null;
    }
};

const addMatch = async (matchData) => {
    try {
        const accessToken = localStorage.getItem('token');
        if (!accessToken) {
            throw new Error("Please Login!!!");
        }
        const headers = {
            authorization: `${accessToken}`,
            'Content-Type': 'application/json',
        };
        let { data } = await axios.post(`${window.host}/match`, matchData, { headers });
        return data;
    } catch (err) {
        if (process.env.NODE_ENV === 'dev') {
            console.error(err.response?.data?.message || err.message);
        }
        return null;
    }
};

export default {getMatches,getMatch,addMatch,updateMatchStatus,deleteMatch}
